import { Loader } from '@consta/uikit/Loader'
import { Text } from '@consta/uikit/Text'

import css from './NewImportLoader.css'

export const NewImportLoader = () => {
  return (
    <div className={css.container}>
      <Text view="primary" weight="bold">
        Ищем результаты по запросу.
      </Text>
      <Text view="primary" weight="bold" className={css.waitText}>
        Подождите немного...
      </Text>
      <Loader className={css.loader} />
    </div>
  )
}
